"use strict";const e=require("react"),n=t=>t&&t.__esModule?t:{default:t},o=n(e),u=o.default.createContext(null);exports.TransitionGroupContext=u;
